import { useCallback } from 'react';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { createManualTaskData } from '../utils/inaccessible-components-analytics';
export const useInaccessibleComponentsAnalytics = _ref => {
  let {
    elements,
    failedElements
  } = _ref;
  const biLogger = useBiLogger();
  const manualTaskDataEvent = useCallback(() => {
    const manualTaskData = createManualTaskData(elements, failedElements);
    biLogger.manualTaskData(manualTaskData);
  }, [biLogger, elements, failedElements]);
  return {
    manualTaskDataEvent
  };
};
//# sourceMappingURL=use-inaccessible-components-analytics.js.map